import { callApi } from "src/core/callApi";

export const unsubscribeUser = async () => {
    const URL = 'https://4rbg8m6w65.execute-api.us-east-2.amazonaws.com/default/unsubscribe_v2';
    try {
      const response = await callApi(
        URL,
        {
          queryParams: {
            // isTest: true,
          },
        },
        true,
        false,
        '',
        'GET',
        true
      );

      if (response?.subscription_cancelled) {
        return true;
      } else {
        console.log('Unsubscription Failed!');
        return false;
      }
    } catch (err) {
      console.log('Unsubscription failed: ', err);
      return false;
    }
  };